import Card from '@/components/Card';
import Container from '@/components/Container';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Divider from '@/components/Divider';
import { DailyBubbleFinishedPage, ResourceEntity } from '@/graphql/generated/graphql';
import { getFinishPage, getLatestResourcesByType } from '@/services/daily/daily-bubble.service';
import { getAuthors } from '@/services/knowledge-hub/utils';
import { useEffect, useState } from 'react';

export default function DailyBubbleFinishPage() {
  const [page, setPage] = useState<DailyBubbleFinishedPage | null>(null);
  const [resources, setResources] = useState<ResourceEntity[]>([]);

  useEffect(() => {
    (async () => {
      const [page, resourcesData] = await Promise.all([getFinishPage(), getLatestResourcesByType()]);

      setPage(page.page);
      setResources(resourcesData.resources);
    })();
  }, []);

  const renderContentSectionByType = () => {
    return resources?.map((card) => {
      const { title, briefDescription, cover } = card.attributes || {};
      return (
        <Card
          key={card.id}
          title={title || ''}
          description={briefDescription || ''}
          tags={
            <DefaultContentTemplateTags
              tags={[card?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
              className="!mb-2 !mt-0"
            />
          }
          author={getAuthors(card)}
          link={`/knowledge-hub/slug/${card.attributes?.slug}`}
          image={{
            url: cover?.data?.attributes?.url || '',
            alternativeText: cover?.data?.attributes?.alternativeText || '',
          }}
        />
      );
    });
  };

  return (
    <div className="my-sh-60">
      <Container>
        <div className="col-span-12 flex flex-col">
          <p className=" text-sh-32-64 font-extralight">{page?.messageSection.youAreDoneTitle}</p>
          <p className="text-sh-80-88 font-extralight">{page?.messageSection.comeBackTitle}</p>
          <Divider />
        </div>
      </Container>

      {/* <DailyBubble containerClassName="!pb-14" /> */}

      <Container>
        <div className=" col-span-4 lg:col-span-12 lg:col-start-3 lg:col-end-11">
          <p className="text-sh-42-32 font-bold">{page?.continueYourWeelbeingJourneyTitle}</p>

          <div className="mt-8 flex flex-wrap gap-4">{renderContentSectionByType()}</div>
        </div>
      </Container>
    </div>
  );
}
